import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"info\">\n    <path fill-rule=\"evenodd\" d=\"M13 0c7.174 0 13 5.826 13 13s-5.826 13-13 13S0 20.174 0 13 5.826 0 13 0zm2.163 19.5a1.619 1.619 0 0 0 0-3.239h-.541v-5.28c0-.72-.389-1.231-1.105-1.231H10.86a1.634 1.634 0 0 0 0 3.266h.507v3.245h-.554a1.62 1.62 0 0 0 0 3.239h4.35zM13 4.32a2.181 2.181 0 1 1 0 4.361 2.181 2.181 0 0 1 0-4.362z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol